export interface Comic {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: 'secret-romance',
    title: '秘密恋爱法则',
    author: '金秀雅',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20comic%20cover%20art%2C%20young%20couple%20standing%20under%20cherry%20blossom%20tree%20at%20sunset%2C%20soft%20pastel%20pink%20and%20warm%20golden%20tones%2C%20clean%20illustration%20style%20with%20delicate%20lineart%2C%20simple%20gradient%20background%2C%20elegant%20Korean%20manhwa%20aesthetic%2C%20dreamy%20atmosphere%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '平凡的高中女生林小月意外发现校草学霸的秘密——他实际上是一个网络漫画作者。两人因漫画结缘，展开了一段甜蜜又充满波折的校园恋爱故事。当秘密被揭开，他们的关系将何去何从？',
    category: 'romance',
    tags: ['校园', '甜宠', '青春'],
    rating: 4.8,
    views: 1280000,
    chapters: 86,
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'blade-of-destiny',
    title: '天命之刃',
    author: '朴志勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20action%20comic%20cover%2C%20warrior%20holding%20glowing%20magical%20sword%20in%20ancient%20eastern%20palace%20setting%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20dynamic%20pose%2C%20clean%20digital%20illustration%20with%20bold%20lineart%2C%20simple%20dark%20gradient%20background%2C%20professional%20manhwa%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在古老的东方大陆，少年剑客韩辰意外获得一柄蕴含天命之力的神剑。从此踏上了一条充满挑战与成长的修炼之路，面对强敌与阴谋，他必须抉择自己的命运。',
    category: 'fantasy',
    tags: ['武侠', '修炼', '热血'],
    rating: 4.9,
    views: 2560000,
    chapters: 152,
    status: '连载中',
    updatedAt: '2026-08-05',
    featured: true,
  },
  {
    id: 'office-love',
    title: '办公室恋曲',
    author: '李恩珠',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20office%20romance%20comic%20cover%2C%20stylish%20man%20and%20woman%20in%20business%20attire%20sharing%20coffee%20in%20modern%20office%2C%20warm%20brown%20and%20cream%20color%20tones%2C%20clean%20elegant%20illustration%2C%20soft%20lighting%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20aesthetic&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '职场新人苏晴进入梦想中的广告公司，却发现自己直属上司是大学时期暗恋过的学长。在工作与感情的交织中，两人逐渐发现彼此内心深处的情感。',
    category: 'romance',
    tags: ['职场', '暗恋', '都市'],
    rating: 4.7,
    views: 980000,
    chapters: 64,
    status: '连载中',
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 'dark-city',
    title: '暗夜都市',
    author: '郑贤宇',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20thriller%20mystery%20comic%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20neon-lit%20city%20alley%20at%20night%2C%20dark%20blue%20and%20purple%20moody%20tones%2C%20noir%20atmosphere%2C%20clean%20digital%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '私家侦探金泰浩接手一桩看似普通的失踪案，却意外卷入了一场惊天阴谋。在追查真相的过程中，他发现每个线索都指向城市最黑暗的角落，而危险也在步步逼近。',
    category: 'thriller',
    tags: ['推理', '都市', '犯罪'],
    rating: 4.6,
    views: 1560000,
    chapters: 48,
    status: '连载中',
    updatedAt: '2026-08-05',
    featured: true,
  },
  {
    id: 'magic-academy',
    title: '魔法学院物语',
    author: '崔美妍',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20magic%20school%20comic%20cover%2C%20young%20students%20in%20magical%20robes%20casting%20colorful%20spells%20in%20grand%20academy%20hallway%2C%20vibrant%20teal%20and%20golden%20color%20scheme%2C%20whimsical%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20art&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '普通高中生李智恩被一封神秘信件带到了隐藏在世界之外的魔法学院。在这里，她发现自己拥有罕见的双系魔法天赋，在学习和冒险中结识了一群志同道合的伙伴。',
    category: 'fantasy',
    tags: ['魔法', '学院', '冒险'],
    rating: 4.8,
    views: 1890000,
    chapters: 120,
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'daily-laugh',
    title: '爆笑日常',
    author: '姜太佑',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20comedy%20slice%20of%20life%20comic%20cover%2C%20funny%20exaggerated%20facial%20expressions%20of%20various%20characters%20in%20everyday%20situations%2C%20bright%20yellow%20and%20orange%20color%20palette%2C%20playful%20and%20energetic%20vibe%2C%20clean%20cartoonish%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '四个性格迥异的大学生住进同一间公寓，每天上演各种令人捧腹的日常喜剧。从抢外卖到考试周崩溃，从宿舍糗事到奇葩约会，笑料不断，轻松解压！',
    category: 'comedy',
    tags: ['日常', '校园', '轻松'],
    rating: 4.5,
    views: 2100000,
    chapters: 200,
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'ghost-detective',
    title: '幽灵侦探',
    author: '尹智勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20horror%20supernatural%20comic%20cover%2C%20person%20with%20pale%20face%20holding%20lantern%20in%20dark%20haunted%20corridor%20with%20eerie%20shadows%2C%20moody%20dark%20green%20and%20gray%20tones%2C%20spooky%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '能看到鬼魂的大学生沈银河意外成为了一名"幽灵侦探"，帮助无法安息的鬼魂解决生前的遗憾。每一个案件背后都隐藏着令人动容的人间故事。',
    category: 'horror',
    tags: ['灵异', '推理', '治愈'],
    rating: 4.7,
    views: 1340000,
    chapters: 72,
    status: '连载中',
    updatedAt: '2026-08-03',
    featured: false,
  },
  {
    id: 'family-drama',
    title: '家的方向',
    author: '韩素英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20family%20drama%20comic%20cover%2C%20multi-generational%20family%20gathered%20around%20dinner%20table%20in%20warm%20cozy%20home%2C%20soft%20earthy%20brown%20and%20cream%20tones%2C%20emotional%20and%20touching%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '讲述三代同堂的韩国家庭故事，从祖母的往事到孙女的叛逆，每个人都在寻找属于自己的"家的方向"。细腻描绘了家人之间的爱与矛盾。',
    category: 'drama',
    tags: ['家庭', '温情', '治愈'],
    rating: 4.9,
    views: 1670000,
    chapters: 56,
    status: '已完结',
    updatedAt: '2026-07-20',
    featured: true,
  },
  {
    id: 'bl-spring-breeze',
    title: '春风十里',
    author: '柳智敏',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20BL%20romance%20comic%20cover%2C%20two%20young%20men%20walking%20together%20along%20spring%20riverside%20path%20with%20cherry%20blossoms%20falling%2C%20soft%20pink%20and%20mint%20green%20color%20palette%2C%20gentle%20and%20tender%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '文艺青年陆之遥在江南古镇偶遇了阳光开朗的画家许诺。两个灵魂在春风中相遇、相知、相爱，用画笔和文字共同描绘属于他们的浪漫故事。',
    category: 'bl',
    tags: ['文艺', '治愈', '日常'],
    rating: 4.8,
    views: 980000,
    chapters: 40,
    status: '已完结',
    updatedAt: '2026-07-15',
    featured: false,
  },
  {
    id: 'martial-legend',
    title: '武林外传之新篇',
    author: '权泰勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20martial%20arts%20action%20comic%20cover%2C%20martial%20artist%20in%20traditional%20robes%20fighting%20on%20bamboo%20forest%20hilltop%20at%20sunrise%2C%20dynamic%20orange%20and%20dark%20green%20color%20scheme%2C%20epic%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '现代青年张凡意外穿越到武侠世界，凭借现代知识和过人的悟性，从一个底层小人物一步步成长为名震江湖的武林传奇。',
    category: 'action',
    tags: ['穿越', '武侠', '成长'],
    rating: 4.7,
    views: 1890000,
    chapters: 98,
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'time-traveler',
    title: '时间旅行者的约定',
    author: '孙艺珍',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20romance%20comic%20cover%2C%20couple%20holding%20hands%20with%20glowing%20pocket%20watch%20and%20swirling%20time%20portal%20in%20background%2C%20dreamy%20purple%20and%20silver%20tones%2C%20mysterious%20and%20romantic%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '拥有穿越时间能力的女孩金允儿在不同的时空里遇到了同一个人。为了守护与他的约定，她一次次穿越时空，揭开隐藏在时间背后的巨大秘密。',
    category: 'fantasy',
    tags: ['穿越', '爱情', '悬疑'],
    rating: 4.9,
    views: 2340000,
    chapters: 110,
    status: '连载中',
    updatedAt: '2026-08-05',
    featured: false,
  },
  {
    id: 'criminal-minds',
    title: '犯罪心理档案',
    author: '赵民秀',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20crime%20thriller%20comic%20cover%2C%20profiler%20examining%20evidence%20board%20with%20red%20strings%20and%20photos%20in%20dimly%20lit%20police%20station%2C%20tense%20dark%20red%20and%20gray%20color%20palette%2C%20intense%20atmosphere%2C%20clean%20illustration%2C%20simple%20gradient%20background%2C%20professional%20manhwa%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '犯罪心理分析师姜河那拥有超凡的推理能力，他带领团队侦破一个又一个令人震惊的连环案件。然而当案件线索指向自己身边的人时，他开始质疑一切真相。',
    category: 'thriller',
    tags: ['推理', '犯罪', '心理'],
    rating: 4.6,
    views: 1760000,
    chapters: 66,
    status: '连载中',
    updatedAt: '2026-08-02',
    featured: false,
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.category === slug);
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter((c) => c.featured);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getLatestComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getPopularComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};